import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY, NAV, SERVICES } from "@/lib/site";

export const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-zinc-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center" data-testid="footer-logo-link">
            <img
              src="/logo-white.png"
              alt="IVrenovation and Construction"
              className="h-12 w-auto object-contain"
            />
          </Link>
          <p className="mt-6 max-w-md text-zinc-400 leading-relaxed">
            Renovation & construction services delivered with architectural precision.
            Tile, bathrooms, kitchens, painting, flooring, electrical, drywall, carpentry.
          </p>
          <div className="mt-8 flex flex-col gap-3 text-sm">
            <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-orange-500 transition" data-testid="footer-phone">
              <Phone className="w-4 h-4 text-orange-500" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-orange-500 transition" data-testid="footer-email">
              <Mail className="w-4 h-4 text-orange-500" /> {COMPANY.email}
            </a>
            <span className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-orange-500" /> {COMPANY.address}
            </span>
            <span className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-orange-500" /> {COMPANY.hours}
            </span>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="overline mb-6">Navigate</h4>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="hover:text-orange-500 transition" data-testid={`footer-nav-${n.label.toLowerCase()}`}>
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="overline mb-6">Services</h4>
          <ul className="grid grid-cols-2 gap-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="hover:text-orange-500 transition" data-testid={`footer-service-${s.slug}`}>
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} {COMPANY.name}.</span>
          <span>Built with precision. Designed to last.</span>
        </div>
      </div>
    </footer>
  );
};
